module.exports = __webpack_public_path__ + "img/page33.9599852d.gif";